<template>
  <div>
    <BaseTable
      :items="loyalties"
      :headers="tableHeaders"
      :loading="loading"
      :pagination="loyaltiesMeta"
      :idPrefix="idPrefix"
      :skeletonCount="7"
      @page-change="pageChange"
    >
      <!-- Custom skeleton slot -->
      <template #skeleton>
        <td class="p-4">
          <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-gray-200 rounded w-1/2"></div>
        </td>
        <td class="p-4">
          <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-gray-200 rounded w-1/2"></div>
        </td>
        <td class="p-4">
          <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-gray-200 rounded w-1/2"></div>
        </td>
        <td class="p-4">
          <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-gray-200 rounded w-1/2"></div>
        </td>
        <td class="p-4">
          <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-gray-200 rounded w-1/2"></div>
        </td>
      </template>

      <!-- Custom item slot -->
      <template #item="{ item }">
        <td class="p-4 text-sm text-gray-900">
          <div>
            {{ item?.details?.["order-id"] }}
          </div>
        </td>
        <td class="p-4 text-sm text-gray-900">
          <div>
            {{ item?.type }}
          </div>
        </td>
        <td class="p-4 text-sm text-gray-900">
          <div>
            {{ item?.points }}
          </div>
        </td>
        <td class="p-4 text-sm">
          <div>
            {{ item?.details?.amount }}
          </div>
        </td>
        <td class="p-4 text-sm flex items-center gap-2">
          <i class="el-icon-date"></i>
          <div>
            {{ item?.["created-at"] | formatDate }}
          </div>
        </td>
      </template>

      <!-- Empty state slot -->
      <template #empty> No Loyalties found </template>
    </BaseTable>
  </div>
</template>

<script>
import { translations } from "@/mixins";
import BaseTable from "@/components/BaseTable.vue";
import BaseCursorPagination from "@/components/BaseCursorPagination";
import moment from "moment";
import BaseLoader from "@/components/BaseLoader.vue";

export default {
  name: "CustomersLoyaltiesV2",

  components: {
    BaseTable,
    BaseCursorPagination,
    BaseLoader,
  },

  filters: {
    formatDate(date) {
      return moment
        .utc(date, "YYYY-MM-D hh:mm:ss")
        .locale("en-us")
        .local()
        .format("MMM D YYYY hh:mm A");
    },
  },

  mixins: [translations],

  props: {
    loyalties: {
      type: Array,
      default: () => [],
    },
    loyaltiesMeta: {
      type: Object,
      default: () => ({
        currentPage: 1,
        totalItems: 0,
        perPage: 10,
        enabled: true,
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      idPrefix: "customer.loyalties.",
      tableHeaders: [],
      pagination: null,
    };
  },

  created() {
    // Set table headers after component is created and mixins are applied
    this.tableHeaders = [
      {
        label: this.translate("order #"),
        id: "headerorderid",
      },
      {
        label: this.translate("type"),
        id: "headertype",
      },
      {
        label: this.translate("points"),
        id: "headerpoints",
      },
      {
        label: this.translate("amount"),
        id: "headeramount",
      },
      {
        label: this.translate("date"),
        id: "headerdate",
      },
    ];
  },

  methods: {
    pageChange(page) {
      if (page !== this.currentPage) {
        this.$emit("getPages", page);
      }
    },
  },
};
</script>

<style scoped>
</style>